import { ReactNode } from "react";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import { RLink } from "./RLink";
import { TestIds } from "../testIds";

export const UpcomingCard = ({
  to,
  onClick,
  image,
  imageAlt,
  title,
  subtitle,
  rightContent,
}: {
  to?: string;
  onClick?: () => void;
  image: string;
  imageAlt: string;
  title: string;
  subtitle: ReactNode;
  rightContent?: ReactNode;
}) => {
  const innerContent = (
    <div
      className="rounded-lg px-2 py-2 transition-colors group-hover:bg-slate-100 dark:group-hover:bg-slate-700/50"
      data-testid={`${TestIds.UpcomingCardHover}-${title}-inner`}
    >
      <div className="flex items-center gap-3">
        <img
          className="h-12 w-12 flex-none rounded-full object-cover"
          src={image}
          alt={imageAlt}
        />

        <div className="flex-1">
          <div className="font-medium text-slate-900 dark:text-white">
            {title}
          </div>

          <div className="mt-1 text-sm text-slate-600 dark:text-slate-400">
            {subtitle}
          </div>
        </div>

        {rightContent && <div className="shrink-0">{rightContent}</div>}
      </div>
    </div>
  );

  return (
    <div
      className="group -mx-2 mb-1"
      data-testid={`${TestIds.UpcomingCardHover}-${title}`}
    >
      {onClick ? (
        <button
          type="button"
          onClick={onClick}
          className="w-full cursor-pointer text-left"
        >
          {innerContent}
        </button>
      ) : to ? (
        <RLink noUnderline to={to}>
          {innerContent}
        </RLink>
      ) : (
        innerContent
      )}
    </div>
  );
};
